// Shared renderer/editing leaf; source automatic derivation remains in slide-auto.
export interface StorySlide {
  /** ★9종 = MSB LAYOUT_COMPONENTS 키와 1:1 + 클라 확장 1종(kineticTypo) = SLIDE_COMPONENTS 10종
   *  (Overlay169 가 동적 조회·미지 타입 가드). 감지(detectSlide)는 기존 4종만 파생 — 나머지
   *  5종(checkList/cardGrid/stepFlow/splitFocus/mediaFocus)은 📐설계도(blueprint) 브릿지의 "명시 주입"
   *  전용(디렉터 설계 재현). 🔤🎞 kineticTypo 는 브릿지가 첫·마지막 M씬의 짧은 fullText 를 승격한
   *  «모션 타이포» — 디렉터 어휘 밖(EF 무개조)·props 는 fullText 와 동일(title·sub). */
  type:
    | "bigNumber" | "statRow" | "comparePair" | "fullText"
    | "checkList" | "cardGrid" | "stepFlow" | "splitFocus" | "mediaFocus"
    | "kineticTypo"
    /* 🪧 포스터 — 그림이 화면을 채우고 그 «위»에 글자가 층층이 쌓인다(벤치 v015 실측 번역).
       `mediaFocus`(액자 + 아래 캡션 한 줄)와 배치가 반대라 별개 종류다. 명시 주입 전용. */
    | "posterStack";
  /** 해당 레이아웃 컴포넌트의 데이터 props(colors/f 제외) — layouts.tsx 계약과 1:1. */
  content: Record<string, unknown>;
}

/** 🔤🎞 «모션 타이포 ↔ 전체 문구» 토글이 성립하는 짝 — 같은 동치 클래스라 서로 오갈 수 있다.
 *  ★이 밖의 타입 전환은 열지 않는다★ — 진짜 구조 변경이라 지문이 옳게 막아야 하는 자리다. */
export const MOTION_TOGGLE_TYPES: ReadonlySet<string> = new Set(["fullText", "kineticTypo"]);

/** 🔤🎞 모션 타이포 제목 상한 — 제목 글자 크기가 hero 고정(kinetic-typo.tsx)이라 이보다 길면
 *  줄바꿈이 쌓여 잘린다. 벤치마크도 «한 문장»이다. */
export const KINETIC_TYPO_TITLE_MAX = 24;

/** 이 제목이 모션 타이포로 성립하는가 — 자동 승격(msb-blueprint.promoteKineticTypo)과 수동 토글
 *  (SceneSlidesSection)이 **같은 술어**를 쓴다. 규칙이 둘로 갈리면 «자동은 되는데 손으로는 안 되는»
 *  칸이 생긴다. */
export const canKineticTypo = (title: string): boolean =>
  !!title && !title.includes("\n") && title.length <= KINETIC_TYPO_TITLE_MAX;

